var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2167 13.7668L13.5334 14.8168C13.3 14.8168 13.1834 15.0502 13.3 15.2835C13.3 15.5168 13.65 15.6335 13.7667 15.5168L14.5834 15.2835C14.7 15.1668 15.1667 15.1668 15.4 15.5168L14 16.1002C13.7667 16.1002 13.65 16.3335 13.7667 16.5668C13.8834 16.9168 14.1167 16.8002 14.2334 16.8002L15.75 16.2168C15.75 16.5668 15.6334 16.9168 15.1667 17.0335L14.2334 17.3835C14.1167 17.5002 14 17.5002 13.8834 17.7335C13.8834 17.9668 13.8834 18.0835 14.1167 18.0835L16.8 19.2502C16.8 19.2502 17.15 19.3668 17.2667 19.0168C17.2667 18.7835 17.3834 18.5502 17.0334 18.4335L15.2834 17.6168C15.9834 17.5002 16.45 16.6835 16.2167 15.9835L16.6834 15.7502C16.9167 15.7502 17.0334 15.5168 16.9167 15.2835C16.9167 15.0502 16.6834 14.9335 16.45 15.0502L15.9834 15.2835C15.75 15.1668 15.75 14.9335 15.4 14.8168L16.2167 14.5835C16.6834 14.3502 16.45 13.7668 16.2167 13.7668Z",
    fill: "#4E4B66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0167 12.1335L25.4333 11.2002L25.7834 12.2502L26.0167 12.1335Z",
    fill: "#4E4B66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95 12.9501L17.6167 4.66675L19.8333 7.58342L22.1667 6.65008L18.2 1.16675L0 14.2334L5.6 21.9334L2.56667 14.2334L5.95 12.9501Z",
    fill: "#4E4B66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.6667L25.55 12.3667L25.2 11.3167L23.3333 6.41675L22.05 6.88341L19.7166 7.81675L6.18329 13.0667L2.91663 14.3501L5.83329 21.8167L7.69996 26.6001L28 18.6667ZM21.9333 9.56675L23.5666 13.8834L24.9666 17.3834L11.3166 22.6334L8.98329 23.5667L7.93329 20.7667L6.06663 15.7501L21.2333 9.91675L21.9333 9.56675Z",
    fill: "#4E4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.ff91daa330e27b5cee1d2e70c8c94165.svg";
export { ForwardRef as ReactComponent };